module.exports = __webpack_public_path__ + "img/旺柴.c42d41ce.png";